import { LegalPage, LegalH, LegalP } from "../components/LegalPage";

export default function CookiePolicy() {
  return (
    <LegalPage title="Cookie Policy" subtitle="Informativa sui cookie ai sensi del GDPR e del Provvedimento del Garante n. 231/2021">
      <LegalH>1. Cosa sono i cookie</LegalH>
      <LegalP>
        I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono
        memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.
      </LegalP>
      <LegalH>2. Cookie utilizzati da questo sito</LegalH>
      <LegalP>
        Questo sito utilizza esclusivamente cookie tecnici, necessari al funzionamento del servizio: gestione della
        sessione di acquisto, memorizzazione delle preferenze sui cookie (banner di consenso) e sicurezza della
        navigazione. Per questi cookie non è richiesto il consenso preventivo.
      </LegalP>
      <LegalH>3. Cookie di terze parti</LegalH>
      <LegalP>
        Durante la fase di pagamento potrai essere reindirizzato a Stripe, che può installare propri cookie tecnici
        e antifrode. Per informazioni: https://stripe.com/it/legal/cookies-policy.
      </LegalP>
      <LegalH>4. Come gestire i cookie</LegalH>
      <LegalP>
        Puoi gestire o eliminare i cookie direttamente dalle impostazioni del tuo browser. La disattivazione dei
        cookie tecnici può compromettere alcune funzionalità del sito, incluso il completamento dell'acquisto.
      </LegalP>
      <LegalH>5. Aggiornamenti</LegalH>
      <LegalP>
        La presente Cookie Policy può essere aggiornata periodicamente. Ti invitiamo a consultarla regolarmente.
        Per qualsiasi domanda: mpcoaching.online@gmail.com.
      </LegalP>
    </LegalPage>
  );
}
